/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { MOKA_COUPON_BILLING_API } from '../constants'

export const VERIFY_COUPON = (coupon) => (`${MOKA_COUPON_BILLING_API}/v1/coupons/${coupon}/verify`)



// WEBPACK FOOTER //
// ./app/api/billingCoupon/constant.js